import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import { Fields as FieldsIcon } from "@air/next-icons";
import classNames from "classnames";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
import { BOARD_COLLECTION_FIELDS_LIST_ITEM } from "~/constants/testIDs";
const getRandomSkeletonWidth = ()=>{
    return Math.random() * (100 - 72) + 72;
};
export const BoardCollectionRequiredFieldItems = (param)=>{
    let { field: { customFieldType, isInvalid, name, required } } = param;
    const FieldIcon = customFieldType ? customFieldIconMap[customFieldType.title] : FieldsIcon;
    return /*#__PURE__*/ _jsxs("li", {
        className: classNames("mb-1 flex items-center px-1 py-1.5 text-14", isInvalid ? "text-flamingo-700" : "text-pigeon-600"),
        "data-testid": "".concat(BOARD_COLLECTION_FIELDS_LIST_ITEM, "-").concat(name),
        children: [
            /*#__PURE__*/ _jsx(FieldIcon, {
                className: "mr-2 size-4 text-inherit"
            }),
            !!name ? /*#__PURE__*/ _jsx("div", {
                className: "text-14 text-inherit",
                children: "".concat(name).concat(required ? " *" : "")
            }) : /*#__PURE__*/ _jsx(Skeleton, {
                height: 20,
                style: {
                    paddingTop: 2,
                    paddingBottom: 2
                },
                width: getRandomSkeletonWidth()
            })
        ]
    });
};
